import React, { useState } from 'react'
import Modal from 'react-modal'
import { useTranslation, initReactI18next } from 'react-i18next'
import axios from 'axios'
import {
  apiURL,
  getUserName,
  cookieSettings,
} from '../../utils/partner_portal_spa'
import { Helmet } from 'react-helmet'
import i18next from 'i18next'

const ModalRegistration = ({ buttonTitle }) => {
  const { t } = useTranslation()
  const locale = i18next.use(initReactI18next).language

  const [modalIsOpen, setIsOpen] = useState(false)
  const [successfull, setsuccessfull] = useState(false)

  const [RegistrationFormData, setRegistrationFormData] = useState({
    gender: 'male',
    first_name: '',
    last_name: '',
    job_title: '',
    company_name: '',
    street: '',
    postal_code: '',
    city: '',
    country: 'DE',
    email: '',
    password: '',
    password_confirmation: '',
    privacy_consent: '',
    newsletter: '',
  })

  const [RegistrationFormErrors, setRegistrationFormErrors] = useState([])

  const openModal = (e) => {
    e.preventDefault()
    setIsOpen(true)
  }
  const closeModal = (e) => {
    e.preventDefault()
    setIsOpen(false)
  }

  const RegistrationFormSubmit = (e) => {
    e.preventDefault()
    axios
      .post(apiURL('auth/signup'), RegistrationFormData, {})
      .then((result) => {
        setsuccessfull(result.data.message)
      })
      .catch((error) => {
        setRegistrationFormErrors(error.response.data.errors)
      })
    return true
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="spa-modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,.5)',
            zIndex: '1060',
          },
        }}
      >
        <Helmet bodyAttributes={{ class: 'overflow-hidden' }}></Helmet>
        <div
          id="spa-modal"
          className="spa-modal modal d-block"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="spa-modal-label"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form
                className="needs-validation"
                onSubmit={(e) => RegistrationFormSubmit(e)}
              >
                <div className="modal-header">
                  <h4 className="modal-title" id="spa-modal-label">
                    {t('generic.user.registration_modal_title')}
                  </h4>
                  <input
                    className="btn btn-close"
                    type="button"
                    value=""
                    onClick={(e) => closeModal(e)}
                  />
                </div>
                <div className="modal-body">
                  <div className="spa-block-full">
                    {successfull && <p>{successfull}</p>}
                    {!successfull && (
                      <>
                        <input type="hidden" name="locale" value="{locale}" />
                        <input
                          type="hidden"
                          name="default_locale"
                          value="{locale}"
                        />
                        <input type="hidden" name="validation_token" />

                        <div className="form-label-group mb-1">
                          <label htmlFor="gender">
                            * {t('generic.user.gender')}
                          </label>
                          <select
                            className="form-control"
                            name="gender"
                            defaultValue={RegistrationFormData.gender}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                gender: e.target.value,
                              })
                            }
                          >
                            <option value="male">
                              {t('generic.user.genders.male')}
                            </option>
                            <option value="male">
                              {t('generic.user.genders.female')}
                            </option>
                            <option value="male">
                              {t('generic.user.genders.diverse')}
                            </option>
                          </select>
                        </div>

                        <div className="row">
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="first_name">
                              * {t('generic.user.first_name')}
                            </label>
                            <input
                              type="text"
                              className={
                                RegistrationFormErrors?.first_name?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="first_name"
                              defaultValue={RegistrationFormData.first_name}
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  first_name: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.first_name?.length > 0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.first_name.join(', ')}
                              </div>
                            )}
                          </div>
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="last_name">
                              * {t('generic.user.last_name')}
                            </label>
                            <input
                              type="text"
                              className={
                                RegistrationFormErrors?.last_name?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="last_name"
                              defaultValue={RegistrationFormData.last_name}
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  last_name: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.last_name?.length > 0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.last_name.join(', ')}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="form-label-group mb-1">
                          <label htmlFor="job_title">
                            {t('generic.user.job_title')}
                          </label>
                          <input
                            type="text"
                            className={
                              RegistrationFormErrors?.job_title?.length > 0
                                ? 'form-control is-invalid'
                                : 'form-control'
                            }
                            name="job_title"
                            defaultValue={RegistrationFormData.job_title}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                job_title: e.target.value,
                              })
                            }
                          />
                          {RegistrationFormErrors?.job_title?.length > 0 && (
                            <div className="invalid-feedback">
                              {RegistrationFormErrors?.job_title.join(', ')}
                            </div>
                          )}
                        </div>

                        <div className="form-label-group mb-1">
                          <label htmlFor="company_name">
                            {t('generic.user.company_name')}
                          </label>
                          <input
                            type="text"
                            className={
                              RegistrationFormErrors?.company_name?.length > 0
                                ? 'form-control is-invalid'
                                : 'form-control'
                            }
                            name="company_name"
                            defaultValue={RegistrationFormData.company_name}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                company_name: e.target.value,
                              })
                            }
                          />
                          {RegistrationFormErrors?.company_name?.length > 0 && (
                            <div className="invalid-feedback">
                              {RegistrationFormErrors?.company_name.join(', ')}
                            </div>
                          )}
                        </div>

                        <div className="form-label-group mb-1">
                          <label htmlFor="street">
                            {t('generic.user.street')}
                          </label>
                          <input
                            type="text"
                            className={
                              RegistrationFormErrors?.street?.length > 0
                                ? 'form-control is-invalid'
                                : 'form-control'
                            }
                            name="street"
                            defaultValue={RegistrationFormData.street}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                street: e.target.value,
                              })
                            }
                          />
                          {RegistrationFormErrors?.street?.length > 0 && (
                            <div className="invalid-feedback">
                              {RegistrationFormErrors?.street.join(', ')}
                            </div>
                          )}
                        </div>

                        <div className="row">
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="postal_code">
                              * {t('generic.user.postal_code')}
                            </label>
                            <input
                              type="text"
                              className={
                                RegistrationFormErrors?.postal_code?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="postal_code"
                              defaultValue={RegistrationFormData.postal_code}
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  postal_code: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.postal_code?.length >
                              0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.postal_code.join(', ')}
                              </div>
                            )}
                          </div>
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="city">
                              * {t('generic.user.city')}
                            </label>
                            <input
                              type="text"
                              className={
                                RegistrationFormErrors?.city?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="city"
                              defaultValue={RegistrationFormData.city}
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  city: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.city?.length > 0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.city.join(', ')}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="form-label-group mb-1">
                          <label htmlFor="country">
                            * {t('generic.user.country')}
                          </label>
                          <select
                            className="form-control"
                            name="country"
                            defaultValue={RegistrationFormData.country}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                country: e.target.value,
                              })
                            }
                          >
                            <option value="DE">
                              {t('generic.user.countries.de')}
                            </option>
                            <option value="NL">
                              {t('generic.user.countries.nl')}
                            </option>
                            <option value="CH">
                              {t('generic.user.countries.ch')}
                            </option>
                            <option value="FR">
                              {t('generic.user.countries.fr')}
                            </option>
                            <option value="GB">
                              {t('generic.user.countries.gb')}
                            </option>
                            <option value="AT">
                              {t('generic.user.countries.at')}
                            </option>
                            <option value="BE">
                              {t('generic.user.countries.be')}
                            </option>
                            <option value="LU">
                              {t('generic.user.countries.lu')}
                            </option>
                            <option value="">
                              {t('generic.user.countries.other')}
                            </option>
                          </select>
                        </div>

                        <div className="form-label-group mb-1">
                          <label htmlFor="email">
                            * {t('generic.user.email')}
                          </label>
                          <input
                            type="text"
                            className={
                              RegistrationFormErrors?.email?.length > 0
                                ? 'form-control is-invalid'
                                : 'form-control'
                            }
                            name="email"
                            defaultValue={RegistrationFormData.email}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                email: e.target.value,
                              })
                            }
                            required
                          />
                          {RegistrationFormErrors?.email?.length > 0 && (
                            <div className="invalid-feedback">
                              {RegistrationFormErrors?.email.join(', ')}
                            </div>
                          )}
                        </div>

                        <div className="row row-passwords">
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="password">
                              * {t('generic.user.password')}
                            </label>
                            <input
                              type="password"
                              className={
                                RegistrationFormErrors?.password?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="password"
                              defaultValue={RegistrationFormData.password}
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  password: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.password?.length > 0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.password.join(', ')}
                              </div>
                            )}
                          </div>
                          <div className="form-label-group mb-1 col-md-6">
                            <label htmlFor="password_confirmation">
                              * {t('generic.user.password_confirmation')}
                            </label>
                            <input
                              type="password"
                              className={
                                RegistrationFormErrors?.password_confirmation
                                  ?.length > 0
                                  ? 'form-control is-invalid'
                                  : 'form-control'
                              }
                              name="password_confirmation"
                              defaultValue={
                                RegistrationFormData.password_confirmation
                              }
                              onChange={(e) =>
                                setRegistrationFormData({
                                  ...RegistrationFormData,
                                  password_confirmation: e.target.value,
                                })
                              }
                              required
                            />
                            {RegistrationFormErrors?.password_confirmation
                              ?.length > 0 && (
                              <div className="invalid-feedback">
                                {RegistrationFormErrors?.password_confirmation.join(
                                  ', '
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <br />
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className={
                              RegistrationFormErrors?.newsletter?.length > 0
                                ? 'form-check-input is-invalid'
                                : 'form-check-input'
                            }
                            name="newsletter"
                            id="newsletter"
                            defaultValue={RegistrationFormData.newsletter}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                newsletter: '1',
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="newsletter"
                          >
                            {t('generic.user.newsletter')}
                            <a
                              href={t('cookie_bar.cookie_link')}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {' '}
                              {t('generic.user.privacy_policy')}
                            </a>
                            .
                          </label>
                        </div>
                        <br />
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className={
                              RegistrationFormErrors?.privacy_consent?.length >
                              0
                                ? 'form-check-input is-invalid'
                                : 'form-check-input'
                            }
                            name="privacy_consent"
                            id="privacy_consent"
                            defaultValue={RegistrationFormData.privacy_consent}
                            onChange={(e) =>
                              setRegistrationFormData({
                                ...RegistrationFormData,
                                privacy_consent: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="privacy_consent"
                          >
                            * {t('generic.user.privacy_consent')}
                            <a
                              href={t('cookie_bar.cookie_link')}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {' '}
                              {t('generic.user.here')}
                            </a>
                            .
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  {!successfull && (
                    <input
                      className="btn btn-primary"
                      type="submit"
                      value={t('generic.user.registration_modal_title')}
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      <div className="row">
        <div className="content-col-1">
          <a className="btn btn-primary" onClick={(e) => openModal(e)}>
            {buttonTitle}
          </a>
        </div>
      </div>
    </>
  )
}

export default ModalRegistration
